module.exports = __webpack_public_path__ + "static/img/4.af3f299.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/eng/4.png
// module id = S/A8
// module chunks = 0